import React, { memo, useState } from 'react'
import useIsMobile from '@/hooks/isMobile'

const PCStyle = React.lazy(() => import('./PC'))
const H5Style = React.lazy(() => import('./H5'))

const GlobalStyle = () => {
  const isMobile = useIsMobile()

  return <>{!isMobile ? <PCStyle /> : <H5Style />}</>
}

export default memo(GlobalStyle)
